import { code } from "@spscommerce/utils";

export const SpsDescriptionListExamples = {
    basic: {
        label: "Basic Description List",
        examples: {
            basic: {
                template: code`
                    <sps-dl>
                        <sps-dt>Term 1</sps-dt>
                        <sps-dd>Definition</sps-dd>
                        <sps-dt>Term</sps-dt>
                        <sps-dd>Definition</sps-dd>
                        <sps-dt>
                            Term that wraps to the next line cause it's got so dang much text in it.
                        </sps-dt>
                        <sps-dd>Definition</sps-dd>
                        <sps-dt>Term</sps-dt>
                        <sps-dd>
                            Definition that has a LOOOOOOOOOOT of text in it.
                            Definition that has a LOOOOOOOOOOT of text in it.
                        </sps-dd>
                    </sps-dl>
                `
            },
            dynamic: {
                template: code`
                    <sps-dl>
                        <ng-container *ngFor="let item of list">
                            <sps-dt>{{item.term}}</sps-dt>
                            <sps-dd>{{item.definition}}</sps-dd>
                        </ng-container>
                    </sps-dl>
                `,
                class: code`
                    class DemoComponent {
                        list = [
                            { term: "Term 1", definition: "Definition 1" },
                            { term: "Term 2", definition: "Definition 2" },
                            { term: "Term 3", definition: "Definition 3" },
                        ];
                    }
                `
            },
        },
    },
    advanced: {
        label: "Advanced Description List",
        examples: {
            advanced: {
                template: code`
                  <sps-dl>
                    <sps-dt>Term</sps-dt>
                    <sps-dd><sps-text-input></sps-text-input></sps-dd>
                    <sps-dt error>Term</sps-dt>
                    <sps-dd><sps-text-input></sps-text-input></sps-dd>
                    <sps-dt required>Term</sps-dt>
                    <sps-dd><sps-text-input></sps-text-input></sps-dd>
                    <sps-dt required error>
                        Term that wraps to the next line cause it has so dang much text in it.
                    </sps-dt>
                    <sps-dd><sps-text-input></sps-text-input></sps-dd>
                  </sps-dl>
                `
            }
        }
    },
    compact: {
        label: "Compact Description List",
        examples: {
            compact: {
                template: code`
                    <sps-dl compact>
                      <sps-dt>Term 1</sps-dt>
                      <sps-dd>Definition</sps-dd>
                      <sps-dt>Term</sps-dt>
                      <sps-dd>Definition</sps-dd>
                      <sps-dt>Term that wraps to the next line cause it's got so dang much text in it.</sps-dt>
                      <sps-dd>Definition</sps-dd>
                      <sps-dt>Term</sps-dt>
                      <sps-dd>Definition that has a LOOOOOOOOOOT of text in it. Definition that has a LOOOOOOOOOOT of text in it.
                      </sps-dd>
                    </sps-dl>
                `
            }
        }
    },
    columnWidths: {
        label: "Alternate Column Widths",
        examples: {
            wideTerms: {
                template: code`
                    <sps-dl wideTerms>
                     <sps-dt>Term 1</sps-dt>
                     <sps-dd>Definition</sps-dd>
                     <sps-dt>Term</sps-dt>
                     <sps-dd>Definition</sps-dd>
                     <sps-dt>Term that wraps to the next line cause it's got so dang much text in it.</sps-dt>
                     <sps-dd>Definition</sps-dd>
                    </sps-dl>
                `
            },
            widerTerms: {
                template: code`
                    <sps-dl widerTerms>
                     <sps-dt>Term 1</sps-dt>
                     <sps-dd>Definition</sps-dd>
                     <sps-dt>Term</sps-dt>
                     <sps-dd>Definition</sps-dd>
                     <sps-dt>Term that wraps to the next line cause it's got so dang much text in it.</sps-dt>
                     <sps-dd>Definition</sps-dd>
                    </sps-dl>
                `
            },
        }
    }
};
